const or = {
  // Navbar
  home: 'Fuula Dura', clients: 'Maamiltoota', news: 'Oduu', about: "Waa'ee Keenya",
  contact: 'Nu Quunnamaa', signIn: 'Seeni', register: "Galmaa'i",
  signOut: "Ba'i", myDashboard: 'Daashboordii Koo', team: 'Garee',

  // Ad splash
  adOf: (i, n) => `Beeksisa ${i} kan ${n}`,
  watchAd: 'Itti fufuuf beeksisa ilaali',
  secondsLeft: (s) => `Sekoondii ${s} hafee`,
  overall: 'Waliigala', complete: 'xumurame',

  // Home
  heroTag: 'Daldala Hayyama Qabaniif Qofa',
  heroTitle1: 'E-Commerce fi Maarketiingii Dijitaalaa',
  heroTitle2: 'Daldala Hayyama Qabaniif',
  heroDesc: 'Argama miidiyaa hawaasaa dhugaa fi furmaata e-commerce uumuuf daldala hayyama qaban qofa waliin hojjenna.',
  // Links page
  linksTagline: 'E-Commerce fi Maarketiingii Dijitaalaa · Finfinnee, Itoophiyaa',
  linksDesc: 'Daldala hayyama qaban mirkana\'ame maarketiingii dijitaalaa, furmaata e-commerce fi argama miidiyaa hawaasaa dhugaa dhaan guddifna.',
  linksWebsite: 'Marsariitii',
  applyNow: 'Amma Iyyaddhu',
  viewClients: 'Maamiltoota Ilaali',
  seeMore: 'Dabalata Ilaali',
  totalClients: 'Maamiltoota', licensed: 'Hayyama Qaban', avgGrowth: 'Guddina Giddu-galeessaa',
  ourServices: 'Tajaajila Keenya',

  // Clients categories
  catAll: 'Hunda', catStartups: 'Dhaabbilee Haaraa',
  catRetail: 'Daldala Xiqqaa fi Guddaa', catHospitality: 'Keessummaa fi Turizimii',
  catEducation: 'Dhaabbilee Barnootaa', catServices: 'Dhiyeessitootaa Tajaajilaa',
  catManufacturers: 'Warshaalee',
  allCities: '📍 Magaalota Hunda', clearFilter: '✕ Haqi',
  noClientsInCity: (city) => `${city} keessatti maamiltoota hin argamne.`,
  noClientsInCategory: 'Ammaaf maamiltoonni kutaa kana keessa hin jiran.',

  // Clients
  ourClients: 'Maamiltoota Keenya',
  verifiedBusinesses: "Daldala mirkana'e hayyama qaban kan beeksifnu",
  verified: "✓ Mirkana'e",
  followers: 'Hordoftootaa', growth: 'Guddina', engagement: 'Hirmaannaa',
  noClients: 'Ammaaf maamiltoota hin jiran.',

  // News
  newsTitle: 'Oduu', latestUpdates: 'Oduu fi barreeffama haaraa',
  readMore: 'Dabalata Dubbisi', noNews: 'Ammaaf barreeffamni hin jiru.',
  readLess: 'Show Less ↑',
  loading: "Fe'aa jira...",
  sourceRef: '📎 Madda / Wabii',
  categories: { General: 'Waliigala', Marketing: 'Maarketiingii', Business: 'Daldala', Technology: 'Teeknooloojii', News: 'Oduu', Events: 'Taateewwan', Tips: 'Gorsa' },

  // About
  aboutTitle: "Waa'ee Keenya", aboutSub: 'Nuti',
  vision: "Mul'ata", mission: 'Ergama',
  visionText: "MSME-oota gargaaruuf Itoophiyaa keessatti dhaabbata maarketiingii dijitaalaa fi beeksisaa duraa ta'uu.",
  missionText: "MSME-oota Itoophiyaa guddina waaraa argachuuf gargaaran furmaata maarketiingii fi beeksisaa haaraa, gatii madaalawaa fi safaramuu danda'u dhiyeessuu.",
  coreValues: "Gatii Bu'uuraa",
  strategicObjectives: 'Kaayyoo Tarsiimoo',
  so1: 'Tajaajila maarketiingii ogummaa qabu biyyatti guutuu dhiyeessuu',
  so2: 'Guddina MSME argamummaa dijitaalaa fi braadingiitiin deeggaruu',
  so3: 'Teeknooloojii (marsariitii, app mobaayilii fi miidiyaa hawaasaa) tajaajila dhiyeessuuf fayyadamuu',
  so4: 'Hirmaannaa dheeraa MSME-oota fi dhaabbilee waliin ijaaruu',
  so5: 'Carraa hojii dargaggoota dandeettii qabaniif uumuu',

  // Contact
  contactTitle: 'Nu Quunnamaa', contactSub: 'Daldalakee guddisuuf qophii dha?',
  fullName: 'Maqaa Guutuu *', email: 'Imeelii', phone: 'Bilbila *',
  company: 'Maqaa Dhaabbata', businessType: 'Gosa Daldala',
  tin: 'Lakkoofsa TIN', elmis: 'Galmee E-LMIS',
  license: 'Hayyama Daldala', message: 'Ergaa',
  submit: 'Iyyannoo Galchi', submitting: 'Galchaa jira...',
  successTitle: 'Ergaan Ergame!', successMsg: 'Galatoomaa! Dafnee si quunnamna.',
  sendAnother: 'Biraa Ergi',
  licenseNote: '📋 Barbaachisaa: Daldala hayyama qaban qofa waliin hojjenna.',
  selectType: 'Gosa filadhu...',
  companyToggle: 'Send as a Company',

  // Register
  registerTitle: 'Herrega daldala kee uumi',
  accountDetails: "Bal'ina Herregaa", businessInfo: 'Odeeffannoo Daldala', documents: 'Sanadoota',
  namePlaceholder: 'Maqaa Guutuu *', passwordPlaceholder: 'Jecha Darbii *',
  confirmPassword: 'Jecha Darbii Mirkaneessi *', minPassword: 'Xiqqaate qubee 6',
  nextBusiness: 'Itti aanaa: Odeeffannoo Daldala', nextDocs: 'Itti aanaa: Sanadoota',
  back: "Deebi'i", createAccount: 'Herrega Uumi', creating: 'Herrega uumaa jira...',
  alreadyHave: 'Herrega qabdaa?',
  businessLicenseReq: 'Lakkoofsa hayyama daldala barbaachisaadha.',
  licenseInfo: '📋 Odeeffannoon kee garee keenya ni madaalama. Galmee booda imeelii siif ergama.',
  companyNameLabel: 'Maqaa Dhaabbata / Daldala *',
  businessTypeLabel2: 'Gosa Daldala',
  locationLabel: 'Bakka (Magaalaa)',
  websiteLabel: 'Marsariitii (dirqama miti)',
  businessLicenseLabel: 'Lakkoofsa Hayyama Daldala *',
  tinLabel: 'Lakkoofsa TIN',
  elmisLabel: 'Galmee E-LMIS',
  phoneLabel2: 'Lakkoofsa Bilbilaa *',
  emailLabel: 'Imeelii (dirqama miti)',
  fullNameLabel: 'Maqaa Guutuu *',
  businessDocsTitle: 'Sanadoota Daldala',
  businessDocsDesc: 'Daldala hayyama qaban qofa waliin hojjenna. Lakkoofsa sanadaa mirkaneessaa galchi.',
  fillRequired: 'Dirreewwan barbaachisoo hunda guuti.',
  passwordMismatch: 'Jechoonni darbii wal hin simatan.',
  passwordShort: 'Jecha darbii xiqqaate qubee 6 qabaachuu qaba.',
  companyRequired: 'Maqaa dhaabbata barbaachisaadha.',
  registrationFailed: "Galmaa'uu hin milkoofne.",

  // Login
  loginTitle: 'Herrega kee seeni',
  phoneLabel: 'Lakkoofsa Bilbilaa',
  passwordLabel: 'Jecha Darbii',
  emailPlaceholder: 'your@email.com',
  loginBtn: 'Seeni', loggingIn: 'Seenaa jira...',
  noAccount: 'Herrega hin qabduu?', registerBusiness: 'Daldala kee galmeessi',
  loginFailed: 'Seenuu hin milkoofne.',

  // Navbar extras
  blogsNews: 'Blogii/Oduu',
  faq: 'Gaaffiiwwan',
  cart: 'Wishlist',
  expandSidebar: 'Saayidaabii Babal\'i',
  collapseSidebar: 'Saayidaabii Cufi',

  // FAQ
  faqTitle: 'Gaaffiiwwan Aragaman Jiru',
  faqSubtitle: 'All Things, Baazaara fi tajaajila keenyaaf barbaachisa malee hunda waa\'ee keessan fe\'amaa jirtan.',
  faq1q: 'All Things maaliitti?',
  faq1a: 'All Things eejensii maarketiingii dijitaalaa fi faayisa e-commerce Finfinnee, Itoophiyaa keessaatiin uumame jedha. Daldala hayyama qabu Itoophiyaa keessaniif tajaajila maarketiingii fi Baazaara keenya waliin daldala keessaniif guddisuu keessatti isin gargaarna.',
  faq2q: 'Akka gurgurtaatti akkamitti galmaa\'a?',
  faq2a: 'Fuula Quunnamaa gara deemaa sanadoota daldala keessanii, lakkoofsa TIN, hayyama daldala fi galmaa\'uun ELMIS dabalaa ta\'ee unka galchaa. Gareen keenya iyyannoo kee ni madaala.',
  faq3q: 'Baazaarirraa akkamitti bitaa?',
  faq3a: 'Baazaara keessatti oomishaalee ilaali, fooyya\'i kaartiin keetti dabali, itti aansuun kaffaluutti deemi. Jalqabsisuuf herrega bitaa galmaa\'i. Kaffaluu gurgurtaa fi kee gidduu sirriin ta\'uun hojjeta.',
  faq4q: 'Mallaqa kaffaluu gochuun isa jedhu?',
  faq4a: 'Mallaqa kaffaluu gosa gurgurtaa irraan jira. Kenna bakka tokkotti baankii, moobayilii maallaqaa yk cash on delivery Finfinnee keessatti galchu. Daldalaa sanaa mallaqa kaffaluu dhuunfaa filachuuf fuula oomisha ilaali.',
  faq5q: 'Geejjibni akkamitti hojjeta?',
  faq5a: 'Geejjibni bitaan booda gurgurtaa waliin sirriin ta\'uun sirreessa. Gurgurtoonni boqonnaa Finfinnee keessatti geejjiba kennu. Tajaajila chaa fi keenyaan gurgurtaa kee waliin geejjiba haala irra waliin yaadadhu.',
  faq6q: 'Keenyuma deebisuun jira?',
  faq6a: 'Keenyumni kee fi gurgurtaa gidduu hojjeta. Bitaa dura keenyuma gurgurtaa fuula keenya irraan fuula fuulaan erguu isin barbaachisa jedhu.',
  faq7q: 'Akka maamilaa maarketiingii dijitaalaa maaliif ta\'a?',
  faq7a: 'Fuula Quunnamaa yk allthingsethiopia2026@gmail.com irraan nu quunnamaa. Daldala barbaachisee keessan waliin yaadna fi karoorta tooftaa maarketiingii uumna.',
  faq8q: 'All Things tajaajila maala kenna?',
  faq8a: 'Daldala Itoophiyaa maarketiingii dijitaalaa, bulchiinsa gabaa hawaasaa, ijaarsa marsariitii, braandingii, uumuun qabiyyee fi furmaata e-commerce kennina.',

  // About extras
  aboutTag: 'Waa\'ee Keenya',
  aboutHeroTitle1: 'Itoophiyaa',
  aboutHeroTitle2: 'Dijitaalaa Guddina',
  aboutCatalyst: 'Nuti MSME-oota Itoophiyaa gabaa ammayyaa keessatti guddisuuf kan tumsu jedha.',
  whoWeAre: 'Nu Akkamitti',
  whoWeAreText: 'Nuti dijitaalaa maarketiingii fi furmaata e-commerce MSME-oota Itoophiyaa tooftaa daldaa sirrii keessaa irraa guaraa ta\'een guddina tooftaa qabeessa dijitaalaa jijjiiruuf gargaaru. Ergama keenya gatii bakka keessa fi gatii adda addaa gidduu jiru ni cufna.',
  ourCoreValues: 'Gatii',
  ourCoreValuesHighlight: 'Bu\'uuraa',
  strategic: 'Tarsiimoo',
  strategicHighlight: 'Kaayyoo',

  // Register extras
  joinAllThings: 'All Things',
  joinAllThingsHighlight: 'Seenu',
  chooseAccountType: 'Jalqabsisuuf herrega gosa kee filadhu',
  registerYourBusiness: 'Daldala hayyama qaban kee tajaajila ogummaa qabuuf galmeessi.',
  haveAccount: 'Herrega qabdaa?',
  signIn: 'Seeni',
  registrationSubmitted: 'Galmaa\'uun Ergame!',
  thankYouName: (name) => `${name} galatoomaa!`,
  thankYouRegistering: 'Herregi kee madaala jira. Gareen keenya daldala kee guyyaa 40 keessatti ni mirkaneessa.',
  goToLogin: 'Gara Seenuutti Deebi\'i',
  phoneMustBe9: 'Bilbilni 6 qubee qabaachuu qaba',
  selectCity: 'Magaalaa filadhu...',

  // Login extras
  forgot: 'Irraanfatte?',

  // Contact info card labels
  labelEmail: 'Imeelii',
  labelLocation: 'Bakka',
  labelPhone: 'Bilbila',
  labelHours: 'Sa\'aatii',
  labelTelegram: 'Telegraamii',
  labelWhatsApp: 'Watsappii',
  contactLocationCity: 'Bakka (Magaalaa)',
  alertFullNameRequired: 'Maqaa guutuu barbaachisaadha',
  alertPhoneDigits: 'Bilbilni 6 qubee qabaachuu qaba (fakkeenyaaf 911031884)',
  alertValidEmail: 'Maaloo teessoo imeelii sirrii galchi',
  alertSubmissionFailed: 'Galchuun hin milkoofne. Maaloo irra deebi\'i yaali.',
  alertCompanyRequired: 'Company name is required.',
  alertTinRequired: 'TIN number is required.',
  alertElmisRequired: 'E-LMIS registration is required.',
  alertBusinessTypeRequired: 'Business type is required.',

  // Chat
  messages: '💬 Ergaawwan',
  noConversations: 'Ammaaf haasawwii hin jiru.',
  selectConversation: 'Haasawwii filadhu jalqabsisuuf',
  typeMessage: 'Ergaa barreessaa...',
  new: 'haaraa',

  // Dashboard
  myDashboardTitle: 'Daashboordii Koo',
  underReview: 'Herregni Madaallii Jala Jira',
  underReviewMsg: 'Gareen keenya odeeffannoo daldala kee madaalaa jira. Guyyaa hojii 1-2 keessatti si quunnamna.',
  profileTab: '👤 Profaayilii', businessTab: '🏢 Odeeffannoo Daldala',
  socialTab: '📱 Hawaasaa fi Dabalata', passwordTab: '🔒 Jecha Darbii',
  saveChanges: 'Jijjiirama Kuusi', saving: 'Kuusaa jira...',
  profileUpdated: "Profaayiliin milkaa'inaan haaromfame.",
  passwordChanged: "Jecha darbiin milkaa'inaan jijjiirameera.",
  currentPassword: 'Jecha Darbii Ammaa', newPassword: 'Jecha Darbii Haaraa',
  confirmNewPassword: 'Jecha Darbii Haaraa Mirkaneessi',
  changePassword: 'Jecha Darbii Jijjiiri',

  // Footer
  footerTagline: 'E-Commerce fi Maarketiingii Dijitaalaa · Finfinnee, Itoophiyaa',
  copyright: '© 2026 All Things Solution PLC',

  // Client detail
  backToClients: "Gara Maamiltoota Deebi'i",
  established: 'Hundeeffame', location: 'Bakka',
  verifiedLicensed: "Daldala Mirkana'e Hayyama Qabu",
  licenseLabel: 'Hayyama',
  ourMarketingWork: 'Hojii Maarketiingii Keenya',
  videoContent: 'Qabiyyee Viidiyoo',
  video: 'Viidiyoo',
  watch: 'Ilaali ↗',
  businessTypeLabel: 'Gosa Daldala',
  contactSocial: 'Nu Quunnamaa fi Miidiyaa Hawaasaa',
  sourceRef: '📎 Madda / Wabii',

  // Services
  service1Title: 'Bulchiinsa Miidiyaa Hawaasaa',
  service1Desc: 'Bulchiinsa guutuu herreega miidiyaa hawaasaa keessan',
  service2Title: 'Uumuu Qabiyyee',
  service2Desc: 'Suuraa, viidiyoo fi graafiiksii ogummaa qabu',
  service3Title: 'Tarsiimoo Guddina',
  service3Desc: "Tarsiimoo guddina irratti hundaa'e",
  service4Title: 'Beeksisa Kaffalamu',
  service4Desc: 'Beeksisa kaayyoo qabu marsaalee hunda irratti',

  // Core values
  cv1Title: 'Haaroomsa fi Uumamummaa', cv1Desc: 'Yaada haaraa fi furmaata uumamaa simanna',
  cv2Title: 'Tajaajila Maamilaa Giddugaleessa', cv2Desc: "Milkaa'ina maamiltoota keenya hundaaf giddugaleessa",
  cv3Title: 'Amanamummaa fi Iftoominaa', cv3Desc: 'Amanamummaa fi iftoominaan hojjenna',
  cv4Title: 'Fudhannaa Teeknooloojii', cv4Desc: 'Meeshaalee dijitaalaa haaraa fayyadamna',
  cv5Title: "Raawwii Bu'aa Xiyyeeffate", cv5Desc: "Bu'aa safaramuu danda'u irratti xiyyeeffanna",

  // Team
  teamOurPeople: 'Namoota Keenya',
  teamTitle: 'Garee',
  teamTitleHighlight: 'Keenya Beeki',
  teamSubtitle: 'Namoota dandeettii qaban All Things Solution duuba jiran',
  teamMember: 'miseensa', teamMembers: 'miseensota',
  depts: {
    'Executive Management': 'Bulchiinsa Olaanaa',
    'Creative & Digital Marketing': 'Maarketiingii Uumamaa fi Dijitaalaa',
    'Technology & Platform Support': 'Deeggarsa Teeknooloojii fi Marsaa',
    'Finance & Administration': 'Maallaqaa fi Bulchiinsa',
    'Customer & Sales': 'Maamilaa fi Gurgurtaa',
  },

  // Bazaar
  bazaarTitle: 'Baazaara',
  bazaarSubtitle: "Oomishaalee gurgurtootaa hunda bakka tokkotti ilaali",
  marketTitle: 'Market',
  marketSubtitle: 'Every product from our verified sellers — always open, no waiting.',
  bestDealToday: '⚡ Best Deal Today',
  bestDealsWeek: '🏆 Best Deals This Week',
  endsIn: 'Ends in',
  // Bazaar & Market filter UI
  filters: 'Filters',
  clearAll: 'Clear All',
  searchLabel: 'Search',
  priceRangeEtb: 'Price Range (ETB)',
  anyPrice: 'Any Price',
  availability: 'Availability',
  inStockOnly: 'In Stock Only',
  allLocations: 'All Locations',
  sellers: 'Sellers',
  applyFilters: 'Apply Filters',
  sortDefault: 'Sort: Default',
  sortNewest: 'Newest First',
  sortPriceAsc: 'Price: Low \u2192 High',
  sortPriceDesc: 'Price: High \u2192 Low',
  sortNameAsc: 'Name: A \u2192 Z',
  statProducts: 'Products',
  statCategories: 'Categories',
  statCities: 'Cities',
  subcategoriesLabel: 'Subcategories:',
  all: 'All',
  resultsNone: 'No products match the current filters',
  resultsCount: (n) => `${n} products`,
  resultsCountOf: (a, b) => `${a} of ${b} products`,
  priceUnder: (a) => `Under ${a} Birr`,
  priceBand: (a, b) => `${a} \u2013 ${b} Birr`,
  priceOver: (a) => `Over ${a} Birr`,
  gridView: 'Grid view',
  listView: 'List view',
  scrollCatLeft: 'Scroll categories left',
  scrollCatRight: 'Scroll categories right',
  marketPlace: 'Market Place',
  marketPlaceWord: 'Place',
  marketTagline: 'Every approved product in one place \u2014 filter by category or location.',
  comingSoon: 'Coming Soon',
  reopensAt: (x) => `Reopens at ${x}`,
  openNow: 'Open',
  closedNow: 'Closed',
  // Bazaar open/closed + countdown
  bazaarMarketplaceWord: 'Marketplace',
  bazaarClosedDesc: 'The All Things Bazaar is currently closed. Check back soon to browse and shop from our verified sellers.',
  opensIn: '⏳ Opens In',
  closesIn: '· Closes in',
  days: 'Days',
  hours: 'Hours',
  minutes: 'Minutes',
  seconds: 'Seconds',
  dayShort: 'd',
  nextBazaar: 'Next Bazaar',
  scheduledByAdmin: 'Scheduled by the admin',
  lastUpdated: 'Last updated',
  hourShort: 'h',
  minuteShort: 'm',
  allClientsLabel: 'All Clients',
  legalTitle: 'Legal / Policies',
  mpCatGridTitle: 'Shop by Category',
  mpCatGridViewAll: 'View All',
  signInToAdd: 'Please sign in to add items to your wishlist.',
  signInRequired: 'Sign In Required',
  wishlistLoginDesc: 'You need to be logged in to add items to your wishlist and start shopping.',
  cancel: 'Cancel',
  soldOut: 'Sold Out',
  bundle: 'BUNDLE',
  sellerStoreTitle: 'Suuqii Gurgurtaa',
  productDetailTitle: "Bal'ina Oomishaa",
  cartTitle: 'Wishlist Kee',
  checkoutTitle: 'Kaffaluu',
  deliveryTitle: 'Geejjiba Gaafadhu',
  addToCart: 'Wishlist Itti Dabaluu',
  added: 'Added',
  addedToWishlist: (name) => '❤️ ${name} added to wishlist!',
  proceedToCheckout: 'Gara Kaffaluutti Itti Fufuu',
  placeOrder: "Ajaja Kaa'i",
  confirmPayment: 'Kaffaluu Mirkaneessi',
  rejectPayment: 'Kaffaluu Didu',
  requestDelivery: 'Geejjiba Gaafadhu',
  addProduct: 'Oomisha Dabaluu',
  editProduct: 'Oomisha Gulaali',
  deleteProduct: 'Oomisha Haqi',
  outOfStock: 'Kuusaan Dhumee',
  inStock: 'Kuusaan Jira',
  pendingPayment: 'Kaffaluu Eegaa Jira',
  confirmedOrder: "Mirkana'e",
  rejectedOrder: 'Didame',
  removedByAdmin: 'Bulchaan Haaqe',
  filterByCategory: 'Gosa Irratti Calaluu',
  filterBySeller: 'Gurgurtaa Irratti Calaluu',
  priceRange: 'Gatii Daangaa',
  searchProducts: 'Oomishaalee Barbaadi...',
  noResults: 'Oomishaaleen hin argamne.',
  selectBank: 'Mala Kaffaluu Filadhu',
  bankAccountNumber: 'Lakkoofsa Herregaa',
  transferInstructions: 'Lakkoofsa herregaa olitti jiru fayyadamuun app baankii keetiin gara herregaatti geejji, itti aansuun ragaa kaffaluu kee gaditti galchi.',
  uploadScreenshot: 'Suuraa Galchi',
  enterReference: 'Lakkoofsa Wabii Galchi',
  orderConfirmation: "Ajajni milkaa'inaan kaa'ame! ID ajaja kee",
  emptyCart: 'Wishlist kee duwwaadha.',
  cartTotal: 'Waliigala',
  unitPrice: 'Gatii Tokkoo',
  quantity: "Baay'ina",
  lineTotal: "Walitti Ida'ama",
  linkedOrder: 'Ajaja Filadhu',
  deliveryAddress: 'Teessoo Geejjibaa',
  contactPhone: 'Bilbila Quunnamtii',
  preferredTime: 'Yeroo Geejjibaa Barbaadamu',
  deliveryConfirmation: "Gaaffiin geejjibaa ergame! ID gaaffii kee",
  myStoreTab: '🛍️ Suuqii Koo',
  myOrdersTab: '📦 Ajajoota Koo',
  myPurchasesTab: '🛒 Bitannoota Koo',
  productName: 'Maqaa Oomishaa',
  productDescription: 'Ibsa',
  productPrice: 'Gatii (ETB)',
  productCategory: 'Gosa',
  productStock: "Baay'ina Kuusaa",
  productPhotos: 'Suuraalee (hanga 5)',
  productNotFound: 'Oomishni hin argamne.',
  sellerNotFound: 'Gurgurtaan hin argamne.',
  outOfStockError: 'Oomishaaleen tokko tokko kuusaan dhumee.',
  deliveryDuplicateError: 'Gaaffiin geejjibaa ajaja kanaaf duraan jira.',
  loginRequired: 'Itti fufuuf maaloo seeni.',
  backToBazaar: "Gara Baazaaraatti Deebi'i",
  allCategories: 'Gosota Hunda',
  allSellers: 'Gurgurtoota Hunda',
  minPrice: 'Gatii Xiqqaa',
  maxPrice: 'Gatii Guddaa',
  viewCart: 'Wishlist Ilaali',
  bankManagement: 'Herreegota Baankii',
  addBankAccount: 'Herrega Baankii Dabaluu',
  noOrders: 'Ammaaf ajajoota hin jiran.',
  noDeliveryRequests: 'Ammaaf gaaffiiwwan geejjibaa hin jiran.',
  waitingConfirmation: 'Mirkaneessa gurgurtaa eegaa jira.',

  // Buyer account
  registerAsSeller: 'Gurgurtaa Galmaa\'i',
  registerAsBuyer: 'Bitaa Galmaa\'i',
  buyerRegisterTitle: 'Herrega bitaa kee uumi',
  myOrders: 'Ajajoota Koo',
  buyerDashboardTitle: 'Seenaa Bitannoo Koo',
  purchaseHistory: 'Seenaa Bitannoo',
  groupedByCategory: 'Gosa Irratti',
  groupedBySeller: 'Gurgurtaa Irratti',
  noPurchases: 'Ammaaf bitannoo hin jiru.',
  instantlyActive: 'Herregni kee hojjechaa jira!',
  buyerRegisterSuccess: 'Galmaa\'uun milkaa\'e!',

  // Home extras
  connectWithUs: 'Nu Quunnamaa',
  ourRoots: 'Bu\'uraa Keenya',
  bridgingTitle: 'Duukkamumsa fi',
  bridgingHighlight: 'Uumamummaa',
  rootsText: 'MSME-oota Itoophiyaa argama dijitaalaa adda addaa keessatti guddisuuf gargaarnu, diinni keenya cunqarfuun. Gabaa ammayyaa irraa gara suuqa dijitaalaatti, guddina keessan waliin hojjenna.',
  ourStory: 'Seenaa Keenya',
  ourServicesTag: 'Tajaajila Keenya',
  whatWeDeliver: 'Akkamitti Dhiyeenna',
  whatWeDeliverHighlight: 'Tajaajila',
  viewMore: 'Dabalata Ilaali',
  servicesBoost: 'Daldalakee Guddisuuf Dhiyeenna Tajaajila',
  readyToScale: 'Daldalakee Guddisuuf Qophii Dha?',
  joinEntrepreneurs: 'Guddina argama dijitaalaa qabu carraa daldalaa Itoophiyaa baayyaa waliin haqaa.',
  appStore: 'App Suuqi',
  googlePlay: 'Guuglaa Playii',

  // Service cards
  svcSocialMedia: 'Bulchiinsa Miidiyaa Hawaasaa',
  svcSocialMediaDesc: 'Herreega miidiyaa hawaasaa keessanii jalqabsiinsa mirkanaa\'u, hordoftootaa fi tooftaa qabiyyee guutuu dhiyeessa.',
  svcContentCreation: 'Uumuu Qabiyyee',
  svcContentDesc: 'Suuraa, viidiyoo fi graafiiksii ergama daldala kee kennu fi yaadannoo kee furu.',
  svcGrowthStrategy: 'Tarsiimoo Guddina',
  svcGrowthDesc: "Tarsiimoo hojii guddina kee siif deeggarsu fi gatii gabaa kee babal'isuuf.",
  svcPaidAds: 'Beeksisa Kaffalamu',
  svcAdsDesc: 'Beeksisa kaayyoo qabu marsaalee hunda irratti ROI siif guddisu fi maamilaa sirrii siif gahe.',
  svcBranding: 'Braandingii fi LooGo Dizaayinii',
  svcBrandingDesc: 'Maqaa daldala yaadamaa, uumuun loogo fi seenaa suuraa kan gurgurtoota adda baasu.',
  svcOutdoor: 'Beeksisa Ala',
  svcOutdoorDesc: 'Baayiloordii, baaneroota fi furmaata argama ala kee maarketiingii dijitaalaa kee gargaarsisu.',
  svcEcommerce: 'E-Commerce Qindeessuu',
  svcEcomDesc: 'Suuqii bitaa guutuu qindeessuu, tarree oomishaa fi All Things Baazaara irratti mirkana\'insa.',
  svcConsultation: 'Madballa Daldala',
  svcConsultDesc: 'Gargaarsa ogummaa qabu fi tooftaa kee gabaa kee argama dijitaalaatti sirriin ta\'uuf.',

  // Clients extras
  ourPartners: 'Waliigala',
  ourPartnersHighlight: 'Haamataa',
  partnersDesc: 'All Things waliin argama dijitaalaa keessanii guddisuuf daldala haaraa Itoophiyaa ilaali.',
  category: 'Gosa',
  allCategoriesLabel: 'Gosota Hunda',
  city: 'Magaalaa',

  // News extras
  updatesTag: 'Haaromfama',
  latestNews: 'Haaraa',
  latestNewsHighlight: 'Oduu',
  newsDesc: "Oduu haaraa Itoophiyaa dijitaalaa ekonomii keessatti jiru irraa odeeffannoo qabaa.",
  sources: 'Maddoota',

  // Team extras
  viewProfile: 'Profaayili Ilaali',

  // Dashboard extras
  personalInformation: 'Odeeffannoo Dhuunfaa',
  businessInformation: 'Odeeffannoo Daldala',
  yearEstablished: 'Waggaa Hundeeffame',
  numberOfEmployees: "Baay'ina Hojjataa",
  socialMediaExtra: 'Miidiyaa Hawaasaa fi Dabalata',
  instagramHandle: '📸 Instagram',
  tiktokHandle: '🎵 TikTok',
  telegramLabel: '✈️ Telegraamii',
  facebookPage: '📘 Facebook Fuula',
  servicesNeeded: 'Tajaajila Barbaachisu',
  servicesNeededPlaceholder: 'Fakkeenyaaf: bulchiinsa miidiyaa hawaasaa, uumuun qabiyyee...',
  aboutYourBusiness: 'Waa\'ee Daldala Keessanii',
  aboutYourBusinessPlaceholder: 'Waa\'ee daldala keessanii nuuf ibsaa...',

  // Order labels
  orderNumber: 'Ajaja #',
  bank: 'Baankii',
  proof: 'Ragaa',
  screenshot: 'Suurii',
  ref: 'Wabii',

  // Marketplace — hardcoded text localized
  mpTopAllCategories: 'All Categories',
  mpTopSearchPlaceholder: 'Search products, businesses, categories...',
  mpTopDashboard: 'Dashboard',
  mpTopRegister: 'Register',
  mpSearchAllCategories: 'All Categories',
  mpSearchAllCities: 'All Cities',
  mpTapToRead: 'Tap to read ▼',
  mpVisitStore: 'Visit Store',
  mpSales: 'sales',
  mpProducts: 'products',
  mpPaymentCreditCard: 'Credit Card',
  mpPaymentBankTransfer: 'Bank Transfer',
  mpPaymentMobileMoney: 'Mobile Money',
  mpPaymentCashDelivery: 'Cash on Delivery',
  mpPaymentTelebirr: 'Telebirr',
  mpFooterHome: 'Home',
  mpFooterBazaar: 'Bazaar',
  mpFooterAbout: 'About Us',
  mpFooterContact: 'Contact',
  mpFooterNews: 'News',
  mpFooterTeam: 'Team',
  mpFooterRegister: 'Register',
  mpFooterDashboard: 'Dashboard',
  mpFooterSellerGuide: 'Seller Guide',
  mpFooterPricing: 'Pricing',
  mpFooterFAQ: 'FAQ',
  mpFooterContactUs: 'Contact Us',
  mpFooterPrivacy: 'Privacy Policy',
  mpFooterTerms: 'Terms of Service',
  mpFooterEthiopia: '🇪🇹 Ethiopia',
  mpFooterEnglish: 'English',

  // Marketplace Homepage
  mpHeroTag: "Ethiopia's #1 Marketplace for Verified Businesses",
  mpHeroTitle: 'Marketplace for',
  mpHeroTitleHighlight: 'Verified Businesses',
  mpHeroDesc: 'Discover trusted Ethiopian businesses, shop quality products, and grow your brand on Africa\'s rising digital marketplace.',
  mpStartShopping: 'Start Shopping',
  mpRegisterBusiness: 'Register Your Business',
  mpStatBusinesses: 'Verified Businesses',
  mpStatProducts: 'Products Listed',
  mpStatCities: 'Cities Covered',
  mpStatSatisfaction: 'Customer Satisfaction',
  mpSearchCategory: 'Category',
  mpSearchLocation: 'Location',
  mpSearchKeyword: 'What are you looking for?',
  mpSearchBtn: 'Search',
  mpTrustVerified: 'Verified Businesses',
  mpTrustSecure: 'Secure Payments',
  mpTrustReturns: 'Easy Returns',
  mpTrust247: '24/7 Support',
  mpTrustVerifiedDesc: 'All businesses are licensed and verified',
  mpTrustSecureDesc: 'Protected transactions every step',
  mpTrustReturnsDesc: 'Hassle-free return policy',
  mpTrust247Desc: 'We are here to help anytime',
  mpCatTag: 'Categories',
  mpCatTitle: 'Shop by',
  mpCatTitleHighlight: 'Category',
  mpCatDesc: 'Browse thousands of products across popular categories',
  mpFeaturedTag: 'Featured',
  mpFeaturedTitle: 'Featured',
  mpFeaturedTitleHighlight: 'Verified Businesses',
  mpFeaturedDesc: 'Top-rated businesses handpicked for quality and trust',
  mpToolsTag: 'MSME Tools',
  mpToolsTitle: 'Everything You Need to',
  mpToolsTitleHighlight: 'Succeed',
  mpToolsDesc: 'Powerful tools designed specifically for Ethiopian MSMEs',
  mpPartnersTag: 'Partners',
  mpPartnersTitle: 'Our Financial',
  mpPartnersTitleHighlight: 'Partners',
  mpPartnersDesc: 'Trusted by leading Ethiopian financial institutions',
  mpPaymentsTag: 'Payments',
  mpPaymentsTitle: 'Secure Payment',
  mpPaymentsTitleHighlight: 'Methods',
  mpPaymentsDesc: 'Multiple secure payment options for your convenience',
  mpTestimonialTag: 'Testimonials',
  mpTestimonialTitle: 'What Our',
  mpTestimonialTitleHighlight: 'Sellers Say',
  mpTestimonialDesc: 'Hear from businesses thriving on All Things',
  mpNewsletterTitle: 'Stay Updated',
  mpNewsletterDesc: 'Subscribe to get the latest deals, new products, and marketplace news delivered to your inbox.',
  mpNewsletterPlaceholder: 'Enter your email',
  mpNewsletterBtn: 'Subscribe',
  mpNewsletterSuccess: '✓ Thank you for subscribing!',
  mpFooterDesc: "Ethiopia's premier digital marketplace connecting verified businesses with customers across the nation.",
  mpFooterQuickLinks: 'Quick Links',
  mpFooterForSellers: 'For Sellers',
  mpFooterSupport: 'Support',
  mpFooterCopyright: '© 2026 All Things Solution PLC. All rights reserved.',
};

export default or;
